{
  "airbrakeProjectId": "472774",
  "airbrakeProjectKey": "d5447d911589519dc7d2b85340e622d0",
  "environment": "local",
  "posApiUrl": "http://localhost:5050/api/v2",
  "configThemesEndpoint": "http://localhost:8080/themes",
  "configMetaEndpoint": "http://localhost:8080/metadata",
  "oidc": {
    "issuer": "https://auth.dev.cityba.se/oauth2/default",
    "clientId": "0oapll2ui0cBoEx7e1d7",
    "scopes": [
      "openid",
      "profile",
      "email",
      "groups",
      "offline_access"
    ],
    "redirectUri": "/login/callback",
    "pkce": true,
    "disableHttpsCheck": false,
    "responseMode": "query",
    "responseType": [
      "token",
      "id_token"
    ]
  },
  "launchDarkly": {
    "clientSideID": "64c9242c67de691386343496"
  }
}
